import React, { useState, useEffect } from 'react'
import { uniqueId } from 'lodash'
import IntentDropdownMenu from './IntentDropdownMenu'

interface IProps {
  intent: any
  scrollToIntent: (intentId: number) => void
  inputJson: any[]
  setInputJson: React.Dispatch<React.SetStateAction<any[]>>
  addIntentRef: any
  data: any
}

const IntentCard: React.FC<IProps> = ({
  intent,
  scrollToIntent,
  inputJson,
  setInputJson,
  addIntentRef,
  data
}) => {
  const [newIntentId, setNewIntentId] = useState('')
  const [showSections, setShowSections] = useState(false)
  useEffect(() => {
    let nextIntentId = 1
    while (inputJson.some((obj) => obj.id === nextIntentId)) {
      nextIntentId++
    }
    setNewIntentId(nextIntentId.toString())
  }, [inputJson])

  const renderIntent = (intent: any) => {
    // Text
    if (!!intent.message.text) {
      return (
        <>
          <div className='d-flex'>
            <h5 className='card-title h4'>
              {!!intent.start ? 'Welcome Intent' : !!intent.end ? 'End Intent' : 'Text'}
            </h5>
            {!!intent.intentDescription && (
              <p
                className='ms-auto text-end  text-mute text-gray-500'
                dangerouslySetInnerHTML={{ __html: intent.intentDescription }}
              />
            )}
          </div>
          {!!intent.message.text && (
            <p
              className='card-text p-0 mt-3 mb-8'
              dangerouslySetInnerHTML={{ __html: intent.message.text }}
            />
          )}
        </>
      )
    }

    // Image
    if (!!intent.message.attachment.type && intent.message.attachment.type === 'image') {
      const imageUrl = intent.message.attachment.payload.url

      return (
        <div className='mb-3'>
          <h5 className='card-title h4'>
            {!!intent.start ? 'Welcome Intent' : !!intent.end ? 'End Intent' : 'Image'}
          </h5>

          {imageUrl ? (
            <div className='text-center'>
              <img
                src={imageUrl}
                alt='image'
                className='img-fluid rounded'
                style={{ maxHeight: '300px', objectFit: 'cover' }}
              />
            </div>
          ) : (
            <p className='text-danger'>Image not available</p>
          )}
        </div>
      )
    }

    // Audio
    if (!!intent.message.attachment.type && intent.message.attachment.type === 'audio') {
      const audioUrl = intent.message.attachment.payload.url

      return (
        <div className='mb-3'>
          <h5 className='card-title h4'>
            {!!intent.start ? 'Welcome Intent' : !!intent.end ? 'End Intent' : 'Audio'}
          </h5>

          {audioUrl ? (
            <div className='text-center'>
              <audio controls style={{ width: '100%' }}>
                <source src={audioUrl} type='audio/mpeg' />
                Your browser does not support the audio element.
              </audio>
            </div>
          ) : (
            <p className='text-danger'>Audio not available</p>
          )}
        </div>
      )
    }

    // Video
    if (!!intent.message.attachment.type && intent.message.attachment.type === 'video') {
      const videoUrl = intent.message.attachment.payload.url

      return (
        <div className='mb-3'>
          <h5 className='card-title h4'>
            {!!intent.start ? 'Welcome Intent' : !!intent.end ? 'End Intent' : 'Video'}
          </h5>

          {videoUrl ? (
            <div className='text-center'>
              <video controls style={{ maxHeight: '300px', width: '100%', objectFit: 'cover' }}>
                <source src={videoUrl} type='video/mp4' />
                Your browser does not support the video tag.
              </video>
            </div>
          ) : (
            <p className='text-danger'>Video not available</p>
          )}
        </div>
      )
    }
  }

  return (
    <>
      <div
        id={`intent-${intent.id}`}
        className='card border border-secondary mb-7'
        style={{
          width: '30rem',
          boxShadow: '0 2px 8px 0 #00000029',
          borderRadius: '15px',
          cursor: 'pointer'
        }}
      >
        <div className='card-body'>
          <div className='d-flex justify-content-between mx-0 px-0 mb-2'>
            <span className='mb-2 me-auto'>
              <span className='ms-1 badge bg-info fs-6'># {intent.id}</span>
            </span>
            <span className='ms-auto text-end' role='button'>
              <div className='d-flex justify-content-center flex-shrink-0'>
                <div ref={addIntentRef}>
                  <IntentDropdownMenu
                    addIntentDropdownMenuRef={addIntentRef}
                    index={intent.id}
                    intent={intent}
                    inputJson={inputJson}
                    setInputJson={setInputJson}
                    newIntentId={newIntentId}
                    setNewIntentId={setNewIntentId}
                    data={data}
                  />
                </div>
              </div>
            </span>
          </div>

          {renderIntent(intent)}

          <div className='d-flex justify-content-between mx-0 px-0 mb-2'>
            {/* {!!intent.userInput && (
              <p className='me-auto text-start mt-2'>
                <span className='ms-2 badge bg-secondary text-info user-select-none'>
                  User Input
                </span>
              </p>
            )} */}
            {!!intent.trigger && (
              <p
                className='ms-auto text-end mt-2'
                role='button'
                onClick={() => scrollToIntent(intent.trigger)}
              >
                <span className='bg-secondary px-2 py-3 rounded text-dark'>
                  Trigger:
                  <span className='ms-2 badge bg-info'>{intent.trigger}</span>
                </span>
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default IntentCard
